//Proofed
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import TuneIcon from '@mui/icons-material/Tune'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import HandshakeIcon from '@mui/icons-material/Handshake'
import DescriptionIcon from '@mui/icons-material/Description'
import { coreBasicPeriod, coreBasicPrice, tenderNinjaPricing } from './PricingContent'

export const steps = [
    {
        Icon: QueryStatsIcon,
        number: '01',
        label: 'Research Your Market',
        heading: 'Comprehensive sector analysis before you bid for anything',
        body: 'The UK public sector is huge. The NHS behaves differently to Defence; local councils operate differently to central government. Before entering any market, you need to know who the buyers are, what they are currently buying, which suppliers are winning and what the political backdrop looks like. CFP gives you the award history, buyer intelligence and framework data to answer these questions before a single pound is spent on bid preparation.',
        bullets: ['Identify the right buyers for your products or services', 'Understand procurement routes: frameworks, open competition, catalogues', 'See who is currently winning and at what value', 'Assess political and funding context before committing'],
    },
    {
        Icon: TuneIcon,
        number: '02',
        label: 'Pick Your Strategy',
        heading: 'Choose a market position you can actually win in',
        body: 'Once you understand the landscape, you need to pick your focus. Which sub-markets, geographies and buyer types will you target? Can you genuinely offer better value or stronger evidence than your competitors? You also need to decide whether to bid as prime contractor or position yourself in the supply chain of a larger firm. Picking the right strategy and committing to it is what separates suppliers who build long term revenue from those who waste months on the wrong opportunities.',
        bullets: ['Define target sectors, geographies and buyer types', 'Assess prime vs subcontractor positioning realistically', 'Build a value proposition that procurement teams can score', 'Commit to a strategy: things in the public sector take time'],
    },
    {
        Icon: HandshakeIcon,
        number: '03',
        label: 'Invest in Target Customers',
        heading: 'Build relationships before the tender is published',
        body: 'Blind bids can occasionally win but that is not a strategy. Suppliers who are known to buyers before a tender is released consistently outperform those who are not. Attend industry days, study annual reports, track previous award publications to estimate when re-procurements are due and make contact early. If you are talking to a buyer before they write their tender, you may be able to influence what they ask for. Most frustrated bidders simply do not put this time in.',
        bullets: ['Track contract expiry dates to identify re-procurement windows', 'Attend industry days and open forums with target buyers', 'Build contact-level relationships before competitions open', 'Use award data to estimate timeline and likely competitors'],
    },
    {
        Icon: DescriptionIcon,
        number: '04',
        label: 'Prepare Bid & Compliance Materials',
        heading: 'Have everything ready before the tender lands',
        body: 'Government bids require a substantial volume of compliance material like ISO certifications, financial statements, insurance evidence, supply chain transparency documentation and a library of credentials from previous customers. Most of this is predictable and can be prepared well in advance. Bids are stressful enough, do not let avoidable admin cost you marks or compliance status. Specialist bid writers can also help SMEs achieve parity with larger firms that employ full bid teams.',
        bullets: ['ISO certifications and accreditation documentation', 'Financial standing evidence and insurance certificates', 'Case studies and customer credentials prepared in advance', 'Bid writing templates and quality review processes'],
    },
    {
        Icon: EmojiEventsIcon,
        number: '05',
        label: 'Choose the Right Tenders',
        heading: 'Bid selectively and go all-in when you do',
        body: 'This is a marathon, not a sprint. Review every opportunity dispassionately, study the mark scheme, assess whether you can realistically score above 85% and be honest about your chances before committing. The UK public sector has thousands of tenders in every category every year. The goal is winning bids, not writing them. When you find the right one, apply full focus on price, solution, formatting and social value, it all counts.',
        bullets: ['Score opportunities against realistic win criteria', 'Use CFP award data to benchmark your position before bidding', 'Apply full resource to the right opportunities', 'Seek feedback on losses and iterate your approach'],
    },
]

export const products = [
    {
        Icon: NotificationsActiveIcon,
        name: 'CFP Core',
        tag: 'Tender Discovery + Market Intelligence',
        colour: '#F4B632',
        description: 'The foundation of the approach. Daily filtered alerts, live tender search, award history, buyer profiles, supplier intelligence and framework tracking all in one platform.',
        href: '/products/core',
        price: coreBasicPrice + ' ' + coreBasicPeriod,
        forWho: 'Solo bidders to full bid teams',
    },
    {
        Icon: QueryStatsIcon,
        name: 'CFP Analytics',
        tag: 'Data Analytics Dashboards',
        colour: '#0891b2',
        description: 'A suite of strategic intelligence dashboards covering the full procurement lifecycle, opportunities by stage, buyer behaviour analysis, supplier competitive intelligence, regional trends and industry sector patterns.',
        href: '/products/analytics',
        price: 'Add-on to Core',
        forWho: 'BD managers and commercial directors',
    },
    {
        Icon: AutoAwesomeIcon,
        name: 'Tender Ninja',
        tag: 'AI Bid-Writing Assistant',
        colour: '#7c3aed',
        description: 'Upload your tender document. Tender Ninja extracts the questions, retrieves relevant content from your knowledge base and generates structured draft responses with word count control, scoring and source attribution.',
        href: '/products/tender-ninja',
        price: tenderNinjaPricing.price + ' ' + tenderNinjaPricing.period,
        forWho: 'Bid writers and BD teams',
    },
]


export const whoItsFor = [
    'Already bidding or ready to bid within 30-90 days',
    'Need confidence you\'re seeing all relevant opportunities',
    'Want faster bid/no-bid decisions backed by data',
    'Overstretched team that needs more bids without more headcount',
    'Serious about win rate, not just volume of submissions',
]
